
























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'quasar'
import SlideshowSetup from 'components/presenter/item/session/manager/SlideshowSetup.vue'
import { select as selectHours } from 'components/modals/Timer.vue'
import { select as selectNumber } from 'components/modals/Number.vue'
import { Session, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    SlideshowSetup
  }
})
export default class SessionManagerSlideSettings extends Vue {
  ItemTypeTopic = ItemTypeTopic
  pad = format.pad

  @Prop()
  readonly session!: Session

  async setRetake () {
    const retakes = await selectNumber(this, {
      title: this.$t('sessions.manager.settings.retakes.title').toString(),
      btnMiddle: this.$t('label.nolimit').toString(),
      value: this.session.retakes,
      min: 0,
      formatter (number: number) {
        return number === null ? '--' : number.toString()
      }
    })
    await this.$emit('save', { retakes })
  }

  async setTimer () {
    const timer = await selectHours(this, {
      title: this.$t('sessions.manager.settings.time.title').toString(),
      value: this.session.data.timer,
      hours: true,
      minutes: true
    })
    await this.$emit('save', { data: { timer } })
  }
}
